// @ts-check
// Ambientes do Matrícula Mais: a homologação (Worker appcrm-staging) roda o mesmo código e build da produção e só muda
// configuração (contrato 08 de homologação); o ambiente vem da var APP_ENVIRONMENT do Worker.
export const APP_ENVIRONMENTS = Object.freeze(['production', 'staging', 'development']);

/** @param {unknown} value @returns {'production' | 'staging' | 'development'} */
export function normalizeAppEnvironment(value) {
  return value === 'staging' || value === 'development' ? value : 'production';
}
